import React from "react";
import styled from "styled-components";
import Logo from "../sharable/Logo";
import Plans from "../sharable/Plans";

const Container = styled.div`
  background-color: #fafafa;
  min-height: 100vh;
  padding: 1.8rem 2.4rem 2.2rem;

  @media (max-width: 900px) {
    padding: 1.2rem 1.4rem 2rem;
  }

  header {
    justify-content: start;
    margin-bottom: 1.2rem;
  }
`;

//COMPONENT VERIFIED 31/05;
export default function PaymentPlansView() {
  return (
    <Container className="flex direction-column">
      <header className="flex">
        <Logo showGoBackButton={true} path="/encartes" />
      </header>
      <Plans title={"Escolha seu plano de assinatura"} />
    </Container>
  );
}
